'use client';

import { ReactNode, useEffect, useRef, useState } from 'react';

import { cn } from '@/app/_helper/tailwind';
import { useMediaQuery } from '@/app/_hooks/useMediaQuery';

type Props = {
    ctaElem: string | ReactNode;
    contentElem: string | ReactNode;
    className?: string;
    arrowClassName?: string;
    shareMobile?: ShareMobileProp;
};

type ShareMobileProp = {
    title: string;
    text: string;
    url: string;
};

const CollectionPopover = ({
    ctaElem,
    contentElem,
    className,
    arrowClassName,
    shareMobile,
}: Props) => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const popoverRef = useRef<HTMLDivElement>(null);

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                popoverRef.current &&
                !popoverRef.current.contains(event.target as Node)
            )
                setIsOpen(false);
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleShare = async (shareMobileProp?: ShareMobileProp) => {
        if (navigator.share && shareMobile && isMobile) {
            try {
                await navigator.share({
                    title: shareMobileProp?.title,
                    text: shareMobileProp?.text,
                    url: shareMobileProp?.url,
                });
                console.debug('Mobile Share Success');
            } catch (error) {
                console.error('Error Mobile Share:', error);
            }
        } else {
            setIsOpen(true);
            console.debug('Web Share API not supported in this browser.');
        }
    };

    return (
        <div className='relative' ref={popoverRef}>
            <div onClick={(): Promise<void> => handleShare(shareMobile)}>
                {ctaElem}
            </div>

            {isOpen && (
                <div
                    className={cn(
                        'absolute -left-[24px] -translate-x-[60%] mt-4 rounded-lg shadow-[0px_16px_100px_32px_#32333d29] bg-white border border-gray-200 p-6 z-10 w-[343px]',
                        className,
                    )}
                >
                    <div
                        className={cn(
                            'absolute top-0 right-[85px] -translate-y-1/2 w-4 h-4 bg-white border border-gray-200 rotate-45',
                            arrowClassName,
                        )}
                    ></div>

                    {contentElem}
                </div>
            )}
        </div>
    );
};

export default CollectionPopover;
